import { Component, OnInit } from '@angular/core';
import { CheckoutParams } from '@luggagehero/shared/interfaces';

import { BookingActionBaseComponent } from '../../../../bookings/index';

@Component({ template: '' })
export abstract class CheckOutActionBaseComponent extends BookingActionBaseComponent implements OnInit {
  public get isCheckoutAllowed(): boolean {
    return true;
  }

  public async checkOut(postponePayment = false) {
    // TODO: Add error handling
    this.isLoading = true;

    const params: CheckoutParams = {
      tip: 0,
      postponePayment,
    };

    const res = await this.bookingService.checkOutForStorageLocation(this.shop._id, this.booking._id, params);
    this.updateBooking(res);

    void this.hideModal();
  }
}
